import { cn, type VariantProps } from "@design-system/utils";
import * as React from "react";

import { linkVariants } from "./link-variants";

interface LinkProps
  extends React.ComponentProps<"a">, VariantProps<typeof linkVariants> {
  newTab?: boolean;
}

function Link({
  className,
  variant,
  newTab = false,
  target,
  rel,
  children,
  ...props
}: LinkProps) {
  return (
    <a
      data-slot="link"
      className={cn(linkVariants({ variant }), className)}
      target={newTab ? "_blank" : target}
      rel={newTab ? "noopener noreferrer" : rel}
      {...props}
    >
      {children}
    </a>
  );
}

export { Link };
export type { LinkProps };
